import { injectable } from 'inversify';
import ZoomedImageComponent from '@/app/zoomable/ui/zoomed-image-component.vue';

const openEvent: string = 'click.zoomable-open';
const closeEvent: string = 'click.zoomable-close';

@injectable()
export class ZoomableService {
  private readonly mainContainerSelector: string = '.main-container';
  private readonly zoomedContainerSelector: string = '.zoomed-image-container';
  private readonly zoomableCssClasses: string = '.image--zoomable, .inline-image--zoomable';

  public listen(): void {
    $(this.mainContainerSelector).off(openEvent).on(openEvent, `${this.zoomableCssClasses}`, (e) => {
      e.stopPropagation();
      this.handleZoomed(e.currentTarget);
    });

    $(this.mainContainerSelector).off(closeEvent).on(closeEvent, this.zoomedContainerSelector, (e) => {
      e.stopPropagation();
      this.handleClosed(e.target);
    });
  }

  public unlisten(): void {
    $(this.mainContainerSelector)
      .off(openEvent)
      .off(closeEvent);
  }

  private handleZoomed(target: any): void {
    const $item = $(target);
    const $img = $('img', $item);
    const imageUri: string = $img.attr('src') as string;
    const component = this.createComponent(imageUri);
    $item.closest(this.mainContainerSelector).append(component.$el);
  }

  private createComponent(imageUri: string): ZoomedImageComponent {
    const component: ZoomedImageComponent = new ZoomedImageComponent({
      propsData: {
        imageUri
      }
    });
    component.$mount();

    return component;
  }

  private handleClosed(target: any): void {
    const $target = $(target);

    if (!$target.hasClass(this.zoomableCssClasses) && $target.closest(`${this.zoomableCssClasses}`).length === 0) {
      $('.image--zoomed').remove();
    }
  }
}

export const ZoomableServiceSymbol = Symbol.for('ZoomableService');
